import * as React from 'react'
import { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Loader } from '@tfo/common'
import $http from '../../../../utils/$http'


interface QueryParams {
    orderId?: string
}

const FinalizeSignature: React.FunctionComponent = () => {
    const params = useParams<QueryParams>()
    const history = useHistory();
    const orderId = params.orderId

    useEffect(() => {
        const finalizeDone = () => {
            history.replace('/candidate')
        }

        if (!orderId) {
            finalizeDone()
        }
        else {
            $http
                .post(`signature/${orderId}/end`, null)
                .finally(finalizeDone);
        }
    }, [orderId, history])
    
    return (<Loader />)
}

export default FinalizeSignature